import { render } from "./LessonDogsTopic1.vue?vue&type=template&id=902a6b8a"
import script from "./LessonDogsTopic1.vue?vue&type=script&lang=js"
export * from "./LessonDogsTopic1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__